import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function OpenRoute({ children }) {
  const { token } = useSelector((state) => state.auth);
  const user = useSelector((state) => state.profile.user);

  if (!token) {
    return children; 
  }

  if (user && user.roles?.length > 0) {
    const allPermissions = user.roles.flatMap(role => role.permissions || []);

  
    const dashboardPermission = allPermissions.find(perm =>
      perm.path.includes("/dashboard")
    );

    if (dashboardPermission?.path) {
      return <Navigate to={dashboardPermission.path} replace />;
    }

    return <Navigate to="/business-dashboard" replace />;
  }

  return null;
}

export default OpenRoute;
